// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Catalogo ruoli predefiniti + vista aggregata "Tutti i ruoli" ======

let _ruoliPredefiniti = []; // cache locale: [{ id, nome, descrizione, perimetro, attivo }]

const ruoliApi = {
  async list({ includeInactive = false } = {}) {
    let q = sb.from('ruoli_predefiniti').select('*').order('perimetro').order('nome');
    if (!includeInactive) q = q.eq('attivo', true);
    const { data, error } = await q;
    if (error) throw error;
    return data || [];
  },
  async upsert({ id, nome, descrizione, perimetro, attivo }) {
    const payload = {
      nome: nome.trim(),
      descrizione: descrizione || '',
      perimetro: perimetro || '',
      attivo: attivo !== false
    };
    if (id) {
      const { error } = await sb.from('ruoli_predefiniti').update(payload).eq('id', id);
      if (error) throw error;
      return id;
    }
    const { data, error } = await sb
      .from('ruoli_predefiniti')
      .insert(payload)
      .select('id')
      .single();
    if (error) throw error;
    return data.id;
  },
  async toggleActive(id, attivo) {
    const { error } = await sb.from('ruoli_predefiniti').update({ attivo }).eq('id', id);
    if (error) throw error;
  },
  async remove(id) {
    const { error } = await sb.from('ruoli_predefiniti').delete().eq('id', id);
    if (error) throw error;
  }
};

async function loadRuoliPredefiniti() {
  try {
    // Usa cache stale-while-revalidate per evitare refetch ad ogni cambio vista
    if (typeof cachedFetch === 'function') {
      _ruoliPredefiniti = await cachedFetch(
        'ruoli-predefiniti',
        () => ruoliApi.list({ includeInactive: true }),
        {
          ttl: 5 * 60_000,
          hardTtl: 30 * 60_000,
          onUpdate: (fresh) => {
            _ruoliPredefiniti = fresh;
          }
        }
      );
    } else {
      _ruoliPredefiniti = await ruoliApi.list({ includeInactive: true });
    }
  } catch (e) {
    console.warn('Impossibile caricare ruoli predefiniti:', e.message || e);
    _ruoliPredefiniti = [];
  }
}

function getRuoliPredefinitiAttivi() {
  return _ruoliPredefiniti.filter((r) => r.attivo);
}

// Per la datalist: ruoli predefiniti + quelli gia' usati su accessi
function allKnownRuoli() {
  const set = new Set();
  getRuoliPredefinitiAttivi().forEach((r) => set.add(r.nome));
  // Aggiungi anche quelli "custom" gia' usati nei dati
  state.clients.forEach((c) => {
    if (!c.accessiMeta) return;
    Object.values(c.accessiMeta).forEach((meta) => {
      (meta.ruoli || []).forEach((r) => set.add(r));
    });
  });
  return [...set].sort();
}

// ====== Vista "Tutti i ruoli" (cruscotto aggregato) ======
const _ruoliViewState = {
  filterPerimetro: '',
  filterAttivo: 'all',
  search: ''
};

function collectRuoliUsage() {
  // Restituisce { ruolo: { count, clienti: Set, risorse: Set } }
  const usage = new Map();
  state.clients.forEach((c) => {
    if (!c.accessiMeta) return;
    Object.entries(c.accessiMeta).forEach(([resName, meta]) => {
      (meta.ruoli || []).forEach((r) => {
        if (!usage.has(r)) usage.set(r, { count: 0, clienti: new Set(), risorse: new Set() });
        const u = usage.get(r);
        u.count++;
        u.clienti.add(c.nome);
        u.risorse.add(resName);
      });
    });
  });
  return usage;
}

async function renderRuoli() {
  if (!isAdmin()) return;
  if (!$('#tbodyRuoli')) return; // vista "ruoli" lazy non ancora montata
  wireRuoliView();
  // Refresh cache da DB
  await loadRuoliPredefiniti();

  const usage = collectRuoliUsage();
  const perimetri = ['', 'Azure', 'M365', 'Power App', 'Whistleblowing', 'IT'];

  // Compone la lista visualizzata: ruoli predefiniti (anche disattivati) + ruoli usati "fuori catalogo"
  const all = new Map();
  _ruoliPredefiniti.forEach((r) =>
    all.set(r.nome, {
      id: r.id,
      nome: r.nome,
      descrizione: r.descrizione || '',
      perimetro: r.perimetro || '',
      attivo: r.attivo,
      predefinito: true,
      usage: usage.get(r.nome) || { count: 0, clienti: new Set(), risorse: new Set() }
    })
  );
  usage.forEach((u, nome) => {
    if (!all.has(nome)) {
      all.set(nome, {
        id: null,
        nome,
        descrizione: '',
        perimetro: '',
        attivo: true,
        predefinito: false,
        usage: u
      });
    }
  });

  // Applica filtri
  let list = [...all.values()];
  if (_ruoliViewState.filterPerimetro)
    list = list.filter((r) => r.perimetro === _ruoliViewState.filterPerimetro);
  if (_ruoliViewState.filterAttivo === 'active') list = list.filter((r) => r.attivo);
  if (_ruoliViewState.filterAttivo === 'inactive') list = list.filter((r) => !r.attivo);
  if (_ruoliViewState.filterAttivo === 'unused') list = list.filter((r) => !r.usage.count);
  if (_ruoliViewState.filterAttivo === 'used') list = list.filter((r) => r.usage.count > 0);
  if (_ruoliViewState.filterAttivo === 'custom') list = list.filter((r) => !r.predefinito);
  if (_ruoliViewState.search) {
    const s = _ruoliViewState.search.toLowerCase();
    list = list.filter(
      (r) => r.nome.toLowerCase().includes(s) || r.descrizione.toLowerCase().includes(s)
    );
  }

  // Ordina: per uso decrescente, poi nome
  list.sort((a, b) => b.usage.count - a.usage.count || a.nome.localeCompare(b.nome));

  // KPI riassuntivi
  const tot = all.size;
  const totUsed = [...all.values()].filter((r) => r.usage.count > 0).length;
  const totCustom = [...all.values()].filter((r) => !r.predefinito).length;
  document.getElementById('ruKpiTot').textContent = tot;
  document.getElementById('ruKpiUsed').textContent = totUsed;
  document.getElementById('ruKpiCustom').textContent = totCustom;

  // Filtri popolazione
  const selP = document.getElementById('filterRuoliPerimetro');
  if (selP) {
    selP.innerHTML =
      '<option value="">Tutti i perimetri</option>' +
      perimetri
        .filter(Boolean)
        .map(
          (p) =>
            `<option value="${escapeHtml(p)}" ${_ruoliViewState.filterPerimetro === p ? 'selected' : ''}>${escapeHtml(p)}</option>`
        )
        .join('');
  }

  // Render tabella
  const tbody = document.getElementById('tbodyRuoli');
  if (!list.length) {
    tbody.innerHTML =
      '<tr><td colspan="6" style="text-align:center;padding:30px;color:var(--text-muted)">Nessun ruolo corrisponde ai filtri.</td></tr>';
    return;
  }
  tbody.innerHTML = list
    .map(
      (r) => `
    <tr data-ruolo="${escapeHtml(r.nome)}" ${r.id ? `data-id="${r.id}"` : ''}>
      <td>
        <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;">
          <strong>${escapeHtml(r.nome)}</strong>
          ${r.predefinito ? '' : '<span class="role-chip" style="background:var(--warning-light);color:var(--warning);">custom</span>'}
          ${r.attivo ? '' : '<span class="role-chip" style="background:#f1f5f9;color:#94a3b8;">disattivato</span>'}
        </div>
        ${r.descrizione ? `<div class="muted" style="font-size:11px;margin-top:2px;">${escapeHtml(r.descrizione)}</div>` : ''}
      </td>
      <td>${r.perimetro ? `<span class="perimeter-pill ${perimetroClass(r.perimetro)}">${escapeHtml(r.perimetro)}</span>` : '<span class="muted">—</span>'}</td>
      <td><strong>${r.usage.count}</strong></td>
      <td>${r.usage.risorse.size}</td>
      <td>${r.usage.clienti.size}</td>
      <td style="display:flex;gap:4px;flex-wrap:wrap;">
        ${
          r.predefinito
            ? `<button class="btn btn-sm" data-act="edit">Modifica</button>
             <button class="btn btn-sm" data-act="toggle">${r.attivo ? 'Disattiva' : 'Attiva'}</button>
             ${r.usage.count === 0 ? '<button class="btn btn-sm btn-danger" data-act="delete">Elimina</button>' : ''}`
            : '<button class="btn btn-sm btn-primary" data-act="promote">Aggiungi al catalogo</button>'
        }
        ${r.usage.count > 0 ? '<button class="btn btn-sm" data-act="drill">Dettaglio uso</button>' : ''}
      </td>
    </tr>
  `
    )
    .join('');

  // Bind eventi
  tbody.querySelectorAll('tr[data-ruolo]').forEach((tr) => {
    const nome = tr.dataset.ruolo;
    const id = tr.dataset.id || null;
    tr.querySelector('[data-act="edit"]')?.addEventListener('click', () =>
      openRuoloModal(id, nome)
    );
    tr.querySelector('[data-act="promote"]')?.addEventListener('click', () =>
      openRuoloModal(null, nome)
    );
    tr.querySelector('[data-act="toggle"]')?.addEventListener('click', () => toggleRuolo(id));
    tr.querySelector('[data-act="delete"]')?.addEventListener('click', () => deleteRuolo(id, nome));
    tr.querySelector('[data-act="drill"]')?.addEventListener('click', () => drillRuolo(nome));
  });
}

function openRuoloModal(id, prefilledNome) {
  const r = id ? _ruoliPredefiniti.find((x) => x.id === id) : null;
  document.getElementById('modalRuoloTitle').textContent = r
    ? 'Modifica ruolo'
    : prefilledNome
      ? `Aggiungi al catalogo: ${prefilledNome}`
      : 'Nuovo ruolo';
  const f = document.getElementById('formRuolo');
  f.reset();
  f.id.value = r?.id || '';
  f.nome.value = r?.nome || prefilledNome || '';
  f.descrizione.value = r?.descrizione || '';
  f.perimetro.value = r?.perimetro || '';
  f.attivo.checked = r ? !!r.attivo : true;
  document.getElementById('modalRuolo').classList.remove('hidden');

  // Dirty guard
  const snapshot = JSON.stringify({
    nome: f.nome.value,
    descrizione: f.descrizione.value,
    perimetro: f.perimetro.value,
    attivo: f.attivo.checked
  });
  if (typeof registerDirtyGuard === 'function') {
    registerDirtyGuard(
      'modal-ruolo',
      () => {
        if (document.getElementById('modalRuolo').classList.contains('hidden')) return false;
        const ff = document.getElementById('formRuolo');
        const now = JSON.stringify({
          nome: ff.nome.value,
          descrizione: ff.descrizione.value,
          perimetro: ff.perimetro.value,
          attivo: ff.attivo.checked
        });
        return now !== snapshot;
      },
      r ? `Ruolo "${r.nome}"` : 'Nuovo ruolo'
    );
  }
}

function closeRuoloModal() {
  document.getElementById('modalRuolo').classList.add('hidden');
  if (typeof unregisterDirtyGuard === 'function') unregisterDirtyGuard('modal-ruolo');
}

async function tryCloseRuoloModal() {
  const ok =
    typeof confirmIfDirty === 'function'
      ? await confirmIfDirty({ confirmText: 'Chiudi senza salvare' })
      : true;
  if (ok) closeRuoloModal();
}

async function toggleRuolo(id) {
  if (!id) return;
  const r = _ruoliPredefiniti.find((x) => x.id === id);
  if (!r) return;
  try {
    await ruoliApi.toggleActive(id, !r.attivo);
    logAudit({
      action: 'update',
      entity: 'Ruolo',
      target: r.nome,
      details: r.attivo ? 'Ruolo disattivato' : 'Ruolo riattivato'
    });
    await renderRuoli();
    toast(r.attivo ? 'Ruolo disattivato' : 'Ruolo riattivato');
  } catch (e) {
    console.error(e);
    toast('Errore: ' + (e.message || e));
  }
}

async function deleteRuolo(id, nome) {
  if (!id) return;
  const ok = await confirmAction({
    level: 'danger',
    title: 'Eliminare ruolo',
    message: `Stai per eliminare il ruolo "${nome}" dal catalogo.`,
    details: [
      "Eliminabile solo se non e' usato in nessun accesso.",
      'Lo storico non viene toccato.'
    ],
    confirmText: 'Elimina ruolo'
  });
  if (!ok) return;
  try {
    await ruoliApi.remove(id);
    logAudit({
      action: 'delete',
      entity: 'Ruolo',
      target: nome,
      details: 'Ruolo eliminato dal catalogo'
    });
    await renderRuoli();
    toast('Ruolo eliminato');
  } catch (e) {
    console.error(e);
    toast('Errore: ' + (e.message || e));
  }
}

function drillRuolo(nome) {
  // Mostra in un confirm modal i clienti e risorse che usano questo ruolo
  const usage = collectRuoliUsage().get(nome);
  if (!usage) return;
  const clienti = [...usage.clienti].sort();
  const risorse = [...usage.risorse].sort();
  confirmAction({
    level: 'info',
    title: `Uso del ruolo "${nome}"`,
    message: `Usato in ${usage.count} access${usage.count === 1 ? 'o' : 'i'}.`,
    details: [
      `Risorse coinvolte (${risorse.length}): ${risorse.join(', ')}`,
      `Clienti coinvolti (${clienti.length}): ${clienti.slice(0, 12).join(', ')}${clienti.length > 12 ? ` … +${clienti.length - 12}` : ''}`
    ],
    confirmText: 'Chiudi',
    cancelText: ''
  });
}

// ====== Event listeners (wiring idempotente: la vista "ruoli" è lazy) ======
let _ruoliWired = false;
function wireRuoliView() {
  if (_ruoliWired) return;
  if (!document.getElementById('btnAddRuolo')) return; // vista non ancora montata
  document.getElementById('btnAddRuolo')?.addEventListener('click', () => openRuoloModal(null));
  document.getElementById('btnRefreshRuoli')?.addEventListener('click', renderRuoli);

  document.getElementById('searchRuoli')?.addEventListener('input', (e) => {
    _ruoliViewState.search = e.target.value;
    renderRuoli();
  });
  document.getElementById('filterRuoliPerimetro')?.addEventListener('change', (e) => {
    _ruoliViewState.filterPerimetro = e.target.value;
    renderRuoli();
  });
  document.getElementById('filterRuoliStato')?.addEventListener('change', (e) => {
    _ruoliViewState.filterAttivo = e.target.value;
    renderRuoli();
  });

  document
    .querySelectorAll('#modalRuolo [data-close-ruolo]')
    .forEach((el) => el.addEventListener('click', tryCloseRuoloModal));

  document.getElementById('formRuolo')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const f = e.target;
    const payload = {
      id: f.id.value || null,
      nome: f.nome.value.trim(),
      descrizione: f.descrizione.value.trim(),
      perimetro: f.perimetro.value,
      attivo: f.attivo.checked
    };
    if (!payload.nome) {
      toast('Nome obbligatorio');
      return;
    }
    try {
      await ruoliApi.upsert(payload);
      logAudit({
        action: payload.id ? 'update' : 'create',
        entity: 'Ruolo',
        target: payload.nome,
        details: `${payload.id ? 'Aggiornato' : 'Creato'} ruolo${payload.perimetro ? ' · perimetro ' + payload.perimetro : ''}`
      });
      closeRuoloModal();
      await renderRuoli();
      toast(payload.id ? 'Ruolo aggiornato' : 'Ruolo creato');
    } catch (err) {
      console.error(err);
      toast('Errore: ' + (err.message || err));
    }
  });
  _ruoliWired = true;
}
wireRuoliView(); // no-op finché la vista lazy non è montata

Object.assign(globalThis, {
  ruoliApi,
  loadRuoliPredefiniti,
  getRuoliPredefinitiAttivi,
  allKnownRuoli,
  renderRuoli,
  collectRuoliUsage,
  openRuoloModal,
  closeRuoloModal,
  tryCloseRuoloModal
});
export {};
